import * as React from 'react';

import type {ListItem} from 'nutshell-core/types';

// @ts-expect-error - imported from .js/.jsx file

import {CloseIcon} from 'shells/icon/svg/close-icon';
import {Popover} from 'shells/popover/popover';
import type {LocationEnum} from 'shells/popover/popover';

import {LeadCardDynamicWrapper} from '../lead/lead-card-dynamic';

import styles from './visual-pipeline-close-confirmation-popover.module.css';

type Props = {
    anchor: HTMLElement | null | undefined;
    children?: any;
    location: LocationEnum;
    onCancel: () => any;
    listItem: ListItem;
    headerText: string;
    fieldsToDisplay: string[];
};

/*
Presentational component to display a popover containing a header, lead card,
and close lead "confirmation" form (yes I want to win this lead). The form acts
as the rendered `children`.
 */
export function VisualPipelineCloseConfirmationPopover(props: Props) {
    const handleCancel = () => {
        props.onCancel();
    };

    return (
        <Popover
            anchor={props.anchor}
            location={props.location}
            overlayStyles={{backgroundColor: '#fff', opacity: 0.5}}
            onBlur={() => {}}
        >
            <div className={styles.container}>
                <header className={styles.header}>
                    <div className={styles['header-text']}>{props.headerText}</div>
                    <div onMouseDown={handleCancel} className={styles['close-button']}>
                        <CloseIcon size={11} />
                    </div>
                </header>
                <div className={styles['card-container']}>
                    <LeadCardDynamicWrapper
                        listItem={props.listItem}
                        hasActionMenu={false}
                        linkable={false}
                        fieldsToDisplay={props.fieldsToDisplay}
                    />
                </div>
                <div className={styles['confirmation-form']}>{props.children}</div>
            </div>
        </Popover>
    );
}
